import type {
  ConnectAccountingOAuthRequest,
  ConnectAccountingOAuthResult,
} from "@src/domain/dto/accountingOAuth";
import type { IAccountingOAuthRepository } from "@src/domain/repositories/accountingOAuth";

export class ConnectAccountingOAuthUseCase {
  private readonly repository: IAccountingOAuthRepository;

  constructor(repository: IAccountingOAuthRepository) {
    this.repository = repository;
  }

  execute(params: ConnectAccountingOAuthRequest): Promise<ConnectAccountingOAuthResult> {
    return this.repository.connect(params);
  }
}
